<template>
  <div class="sample-hr">
    <FormattedHeader
      header="Sample HR Material"
      subheader="Examples Include:"
    />
    <div
      class="max-w-sm sm:max-w-7xl mx-auto grid grid-cols-12 px-2 pl-10 sm:pl-20"
    >
      <div
        v-for="(policy, index) in policies"
        :key="`sample-${index}`"
        class="sample-item max-w-xs col-span-12 sm:col-span-6 lg:col-span-4"
      >
        <div class="flex items-center py-4">
          <figure class="image is-24x24 mr-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="20"
              height="16"
              viewBox="0 0 20 16"
            >
              <defs>
                <path
                  id="check-a"
                  d="M21.7113164,6.25318114 L8.07134908,19.0860301 C7.71316812,19.4196365 7.15680582,19.4196365 6.80771575,19.0622011 L2.26590845,14.4796954 C1.91136385,14.1222599 1.91136385,13.5411982 2.26590845,13.1837628 C2.62045306,12.8244943 3.19681531,12.8244943 3.55135992,13.1837628 L7.47498688,17.1393817 L20.4695012,4.91325647 C20.8349549,4.56865204 21.4113171,4.58698207 21.7531345,4.95724853 C22.0985882,5.32568199 22.0785882,5.90674371 21.7113164,6.25318114 Z"
                />
              </defs>
              <use
                fill="#28C5AA"
                fill-rule="evenodd"
                transform="translate(-2 -4)"
                xlink:href="#check-a"
              />
            </svg>
          </figure>
          <TypeBody
            :variant="$options.Typography.Body.LARGE"
            :weight="$options.Typography.Weights.REGULAR"
            tag="p"
            class="label"
          >
            {{ policy }}
          </TypeBody>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { TypeBody, constants } from '@bambeehr/pollen';
import FormattedHeader from '@/components/FormattedHeader.vue';
const { Typography } = constants;

export default defineComponent({
  name: 'SampleHr',
  Typography,
  components: { FormattedHeader, TypeBody },
  data() {
    return {
      policies: [
        'Offer Letter',
        'Sick Leave Policy',
        'Non-Disclosure Agreement',
        'HIPAA Notice',
        'Non-Solicitation Agreement',
        'Discrimination & Harassment Policy',
        'Notice To Employee',
        'Non-Compete Agreement',
        'Dress Code Policy',
        'Meal & Break Policy',
        'Absenteeism and Tardiness Policy',
        'Smoking Policy',
        'PTO Policy',
        'Social Media Policy',
        'Independent Contractor Agreement',
        'Pet Policy',
        'Gift Policy',
        'Bereavement Policy',
        'Remote Work Policy',
        'Fraternization Policy',
        'Substance Abuse Policy',
      ],
    };
  },
});
</script>
